import type { Table } from '@tanstack/react-table';
import { memo } from 'react';
import DataTableRefresh from '../components/DataTableRefresh';
import DataTableTotal from '../components/DataTableTotal';

interface TotalAndStatsProps<TData> {
  live?: React.ReactNode;
  onRefresh?: () => void;
  isFetching: boolean;
  isLoading: boolean;
  totalRows: number;
  showTotal: boolean;
  table: Table<TData>;
  data: TData[];
  stats?: any;
}

const DataTableStats = <TData,>({ onRefresh, isFetching, isLoading, totalRows, showTotal, table, data, stats: Stats, live }: TotalAndStatsProps<TData>) => {
  const shouldRenderStats = showTotal || Stats || live || onRefresh;

  if (!shouldRenderStats) return null;

  return (
    <div className='grid min-h-8 grid-flow-row-dense grid-cols-12 flex-row items-center justify-between gap-2 space-y-2 tablet:space-y-0'>
      <div className='col-span-12 tablet:col-span-2 flex items-center space-x-2'>
        {live}
        <DataTableRefresh onRefresh={onRefresh} isFetching={isFetching || isLoading} />
        {showTotal && <DataTableTotal isLoading={isLoading} totalRows={totalRows} />}
      </div>
      <div className='col-span-12 tablet:col-span-10 flex flex-wrap justify-start tablet:justify-end'>{Stats?.(table, data || [])}</div>
    </div>
  );
};

export default memo(DataTableStats);
